import {Injectable, TemplateRef} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AdminValetService } from 'src/app/admin/modules/admin-valet/services/admin-valet.service';
import { LinkDisplayColumnComponent } from 'src/app/shared/components/link-display-column/link-display-column.component';
import { FilterConfig } from 'src/app/shared/models/filter-config.interface';
import { BackendFilteringObject, GridColumnConfig } from 'src/app/shared/models/grid-config.interface';

@Injectable({
  providedIn: 'root'
})
export class CommonValetWithholdingConfig {

  public static readonly FILTER_KEYS = {
    VALET_ID: 'valetId',
  } as const;

  public static readonly ALL_FILTER_KEYS = Object.values(CommonValetWithholdingConfig.FILTER_KEYS);

  constructor(
    private translateService: TranslateService) {}

  public getCommonValetWithholdingColumnConfig(
    totalAmountTemplate?: TemplateRef<LinkDisplayColumnComponent>,
    remainingAmountTemplate?: TemplateRef<LinkDisplayColumnComponent>,
    allowInExpensesTemplate?: TemplateRef<LinkDisplayColumnComponent>,
    actionsTemplate?: TemplateRef<LinkDisplayColumnComponent>): GridColumnConfig[] {
    const columns: GridColumnConfig[] = [];

    columns.push({
        key: 'name',
        label: this.translateService.instant('modules.valet.valet_profile.withholdings.grid.name'),
        type: 'string',
        sort: true,
        filter: true,
      },
    );

    if (totalAmountTemplate) {
      columns.push({
          key: 'totalAmount',
          label: this.translateService.instant('modules.valet.valet_profile.withholdings.grid.total_amount'),
          type: 'custom',
          template: totalAmountTemplate,
          sort: true,
          filter: true,
        },
      );
    }

    if (remainingAmountTemplate) {
      columns.push({
          key: 'remainingAmount',
          label: this.translateService.instant('modules.valet.valet_profile.withholdings.grid.remaining_amount'),
          type: 'custom',
          template: remainingAmountTemplate,
          sort: true,
          filter: true
        },
      );
    }

    columns.push({
        key: 'totalInstallments',
        label: this.translateService.instant('modules.valet.valet_profile.withholdings.grid.total_installments'),
        type: 'string',
        sort: true,
        filter: true
      },
    );

    columns.push({
        key: 'remainingInstallments',
        label: this.translateService.instant('modules.valet.valet_profile.withholdings.grid.remaining_installments'),
        type: 'string',
        sort: true,
        filter: true
      },
    );

    if (allowInExpensesTemplate) {
      columns.push({
          key: 'allowInExpenses',
          label: this.translateService.instant('modules.valet.valet_profile.withholdings.grid.allow_in_expenses'),
          type: 'custom',
          template: allowInExpensesTemplate,
          sort: true,
          filter: true
        },
      );
    }

    if (actionsTemplate) {
      columns.push({
        key: 'actions',
        label: 'Actions',
        type: 'custom',
        template: actionsTemplate,
        sort: false,
        filter: false,
        width: '80px'
      });
    }

    return columns;
  }

  getFilterKeys(): string[] {
      return Object.values(CommonValetWithholdingConfig.FILTER_KEYS);
    }
  
    getFilterKeyMapping(): { [key: string]: string } {
      const mapping: { [key: string]: string } = {};
      this.getFilterKeys().forEach(key => {
        mapping[key] = key;
      });
      return mapping;
    }
  
    public getFiltersConfig(): FilterConfig[] {
      return [];
    }

  public createGridConfig(
    filtersStorageKey: string,
    sortStorageKey: string,
    adminValetService: AdminValetService,
    router: any,
    activeRoute: any,
    valetId: string
  ) {
    return {
      entityName: 'CommonValetWithholdingGrid',
      storageKeys: {
        filters: filtersStorageKey,
        sort: sortStorageKey,
      },
      autoLoad: true,
      filterFields: {
        valetId: {
          backendField: 'valetId',
          persistent: true
        }
      },
      apiService: {
        getData: (filterObj: BackendFilteringObject) => {
          return adminValetService.getWithholdings(valetId, filterObj);
        },
        exportPageData: (data) => adminValetService.exportValetWithHoldingsPageData(data)
      },
      routerDependencies: {
        router: router,
        activatedRoute: activeRoute
      }
    };
  }
}
